import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { size, startCase } from 'lodash'
import { Grid, Segment, Header, Divider, Button } from 'semantic-ui-react'
import styled from 'styled-components'

import ExpressActions from '../../reducers/expressReducer'

import ExpressList from './components/ExpressList'
import Loading from '../../components/common/loading'
import DriversBar from '../orders/components/DriversBar'
import ExpressTabBar from './components/ExpressTabBar'

import ModalEditNote from '../../components/express/ModalEditNote'
import ModalAssignDriver from '../../components/orders/ModalAssignDriver'

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

class Express extends Component {
  state = {
    tab: 'all',
    modalAssignVisible: false,
    assignDriverData: null,

    modalEditNoteVisible: false,
    modalEditNoteData: null,
  }

  componentDidMount() {
    const { connected, syncExpress } = this.props

    if (!connected) syncExpress()
  }

  onManualAssign = (orderUid) => {
    const { express } = this.props
    const { tab } = this.state

    const orders = express[tab]
    const order = orders[orderUid]

    this.setState({
      modalAssignVisible: true,
      assignDriverData: [order],
    })
  }

  showEditNote = order => {
    this.setState({ modalEditNoteVisible: true, modalEditNoteData: order })
  }

  render() {
    const { loading, express } = this.props
    const { tab, modalAssignVisible, assignDriverData, modalEditNoteVisible, modalEditNoteData } = this.state

    const orderCount = size(express[tab])
    const headerLabel = `${startCase(tab)} (${orderCount})`
    const orders = express[tab]

    const mainOrder = assignDriverData && assignDriverData[0]

    return (
      <div>
        <Loading active={loading && express.data} />

        <Grid style={{ position: 'sticky', zIndex: 3, top: -14 }}>
          <Grid.Column width="16">
            <Segment color="black">
              <div style={{ textAlign: 'center' }}>
                <DriversBar orders={Object.values(orders || {})} />
              </div>

              <React.Fragment>
                <Divider />
                <ExpressTabBar
                  express={express}
                  activeTab={tab}
                  onChange={newTab => this.setState({ tab: newTab.value })}
                />
              </React.Fragment>

            </Segment>
          </Grid.Column>
        </Grid>

        <Grid style={{ zIndex: 2 }}>
          <Grid.Column width="16">
            <Segment color="black">
              <HeaderContainer>
                <Header size="large">{headerLabel}</Header>
                {tab === 'sameDayOrders' ? (
                  <Link to="/express/queue-orders" style={{ float: 'right' }}>
                    <Button floated='right'>Queue Orders</Button>
                  </Link>
                ) : null}
              </HeaderContainer>
              <ExpressList express={orders} showManualAssign={this.onManualAssign} />
            </Segment>
          </Grid.Column>

          <ModalAssignDriver
            isExpressOrder
            action="manual"
            visible={modalAssignVisible}
            order={mainOrder}
            queueOrders={[]}
            onCancel={() => this.setState({ modalAssignVisible: false, assignDriverData: null })}
          />

          <ModalEditNote
            visible={modalEditNoteVisible}
            order={modalEditNoteData}
            onCancel={this.dismissModalEditNote}
          />
        </Grid>
      </div>
    )
  }
}

const mapState = ({ express }) => ({
  express,
  loading: express.loading,
  connected: express.connected,
})

const mapDispatch = {
  syncExpress: ExpressActions.syncExpress,
}

export default connect(
  mapState,
  mapDispatch
)(Express)



// WEBPACK FOOTER //
// ./src/containers/express/index.js